export const PRIVACY_URL = 'https://covie.com/legal/end-user-privacy'
